<template>
  <div>
    <div class="flex justify-between w-full">
      <p class="text-left py-8 text-green-700 text-2xl">
        Informations sur le bois de France de votre projet
      </p>
    </div>
  <div class="flex justify-between w-full">
    <form class="flex-grow w-full">
      <div class="flex flex-wrap -mx-3 mb-0">
          <div class="w-full px-3">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="project-name">
                  Nom de votre projet (chantier, client…)
              </label>
              <input v-model="projectName" class="appearance-none block
              w-full bg-gray-200 text-gray-700
              border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none
                  focus:bg-white focus:border-gray-500" id="project-name" type="text"
                  placeholder="Inscrivez le nom de votre projet …">
          </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-1">
          <div class="w-full md:w-1/2 px-3">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="selectedSurface">
                  Surface de plancher (en m²)
              </label>
              <input v-model="selectedSurface"
              class="appearance-none block w-full bg-gray-200 text-gray-700
              border border-gray-200
              rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white
               focus:border-gray-500"
                  id="selectedSurface" type="number" placeholder="250">
          </div>
          <div class="w-full md:w-1/2 px-3">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="selectedVolume">
                  Volume de bois (en m3)
              </label>
              <input v-model="selectedVolume"
              class="appearance-none block w-full bg-gray-200 text-gray-700
              border border-gray-200
              rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white
               focus:border-gray-500"
                  id="selectedVolume" type="number" placeholder="100">
          </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-2">
          <div class="w-full px-3">
              <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              for="grid-state">
                  Essence
              </label>
              <div class="relative">
                  <select v-model="selectedEssence" class="block appearance-none w-full bg-gray-200
                  border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight
                  focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                  <option v-for="(option, index) in essences"
                  v-bind:key="index" v-bind:value="option.id">
                      {{ option.title }}
                  </option>
                  </select>
                  <div class="pointer-events-none absolute inset-y-0 right-0
                  flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
              </div>
          </div>
      </div>
      <!-- <div class="flex flex-wrap -mx-3 mb-2">
          <div class="w-full px-3">
              <button @click="calculate()"
              class="bg-transparent hover:bg-green-500 text-green-700 font-semibold
              hover:text-white border border-green-500 hover:border-transparent font-bold py-6
              px-20 rounded inline-flex items-center">
                  <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
                  <span>Calculer</span>
              </button>
          </div>
      </div> -->
    </form>
  </div>
</div>
</template>

<script>
function findEssenceByIndex(selectedEssence, essences) {
  return essences.find((el) => el.id === selectedEssence);
}

function formatFrenchNumber(value) {
  return new Intl.NumberFormat('fr-FR').format(value);
}

function calculateCo2Emissions(selectedVolume, selectedSurface, essence) {
  const projectEmissions = selectedVolume * essence.gwpFossil;
  let m2Emissions = null;
  if (selectedSurface) {
    m2Emissions = projectEmissions / selectedSurface;
  }

  return {
    project: projectEmissions.toFixed(0),
    m2: m2Emissions.toFixed(1),
  };
}
function calculateBiogenic(selectedVolume, selectedSurface, essence) {
  const projectEmissions = selectedVolume * essence.gwpBiogenic;
  const projectBiogenic = (projectEmissions) * (12 / 44);
  let m2Emissions = null;
  let m2Biogenic = null;
  if (selectedSurface) {
    m2Emissions = projectEmissions / selectedSurface;
    m2Biogenic = m2Emissions * (12 / 44);
  }
  return {
    project: projectBiogenic.toFixed(1),
    m2: m2Biogenic.toFixed(1),
  };
}

function calculateCapturedCo2Emissions(selectedVolume, selectedSurface, essence) {
  const projectEmissions = selectedVolume * essence.gwpBiogenic;
  let m2Emissions = null;
  if (selectedSurface) {
    m2Emissions = projectEmissions / selectedSurface;
  }

  return {
    project: projectEmissions.toFixed(0).toLocaleString('fr'),
    m2: parseFloat(m2Emissions).toFixed(1),
  };
}
function getStoredCo2(capturedCo2Emmisions, euForest) {
  let projectResult = formatFrenchNumber(
    (-capturedCo2Emmisions.project / euForest.gwpTotal).toFixed(1),
  );
  if (projectResult < 1) {
    projectResult = '<1';
  }
  let m2Result = formatFrenchNumber((-capturedCo2Emmisions.m2 / euForest.gwpTotal).toFixed(1));
  if (m2Result < 1) {
    m2Result = '<1';
  }
  return {
    project: projectResult,
    m2: m2Result,
  };
}
function calculateCarEmissions(co2Emmisions, carEmissionsRef) {
  return {
    project: (co2Emmisions.project / carEmissionsRef.gwpTotal).toFixed(0),
    m2: (co2Emmisions.m2 / carEmissionsRef.gwpTotal).toFixed(0),
  };
}
function calculatePowerConsumption(co2Emmisions, electricityEmissions) {
  let m2Result = formatFrenchNumber((co2Emmisions.m2 / electricityEmissions.gwpTotal).toFixed(1));
  if (m2Result < 1) {
    m2Result = '<0,1';
  }
  return {
    project: formatFrenchNumber((co2Emmisions.project / electricityEmissions.gwpTotal).toFixed(1)),
    m2: m2Result,
  };
}

export default {
  name: 'CalculationForm',
  props: {
    essences: { type: Array, required: true },
    materials: { type: Object, required: true },
    other: { type: Object, required: true },
  },
  data() {
    return {
      result: {},
      projectName: '',
      selectedSurface: 1,
      selectedVolume: 1,
      selectedEssence: null,
    };
  },
  computed: {
  },
  updated() {
    this.calculate();
  },
  methods: {
    emitCO2Calculated() {
      this.$emit('CO2Calculated', this.result);
    },
    calculate() {
      if (!this.selectedEssence) {
        return;
      }
      if (this.selectedSurface < 1) {
        console.log('Minimum value for selectedSurface is 1');
        this.selectedSurface = 1;
      }
      if (this.selectedVolume < 1) {
        console.log('Minimum value for selectedVolume is 1');
        this.selectedVolume = 1;
      }
      // find essence data
      const essence = findEssenceByIndex(this.selectedEssence, this.essences);
      if (!essence) {
        // no essence found return null
        return;
      }
      const co2Emmisions = calculateCo2Emissions(
        this.selectedVolume, this.selectedSurface, essence,
      );
      const biogenic = calculateBiogenic(
        this.selectedVolume, this.selectedSurface, essence,
      );
      const capturedCo2Emmisions = calculateCapturedCo2Emissions(
        this.selectedVolume, this.selectedSurface, essence,
      );
      // this.result.co2Emmisions = co2Emmisions;
      this.result.co2Emmisions = {
        project: formatFrenchNumber(co2Emmisions.project),
        m2: formatFrenchNumber(co2Emmisions.m2),
      };
      this.result.biogenic = {
        project: formatFrenchNumber(biogenic.project),
        m2: formatFrenchNumber(biogenic.m2),
      };
      this.result.capturedCo2Emmisions = {
        project: formatFrenchNumber(capturedCo2Emmisions.project),
        m2: formatFrenchNumber(capturedCo2Emmisions.m2),
      };
      this.result.netEmmissions = {
        project: formatFrenchNumber(parseInt(co2Emmisions.project, 10)
         + parseInt(capturedCo2Emmisions.project, 10)),
        m2: formatFrenchNumber(parseInt(co2Emmisions.m2, 10)
         + parseInt(capturedCo2Emmisions.m2, 10)),
      };
      this.result.woodNetEmissions = {
        project: Math.floor(co2Emmisions.project)
         + Math.floor(capturedCo2Emmisions.project),
        m2: parseInt(co2Emmisions.m2, 10)
         + parseInt(capturedCo2Emmisions.m2, 10),
      };
      this.result.storedCo2 = getStoredCo2(capturedCo2Emmisions, this.other.euForest);
      const carEmmisions = calculateCarEmissions(co2Emmisions, this.other.carEmissions);
      this.result.carEmmisions = {
        project: formatFrenchNumber(carEmmisions.project),
        m2: formatFrenchNumber(carEmmisions.m2),
      };
      this.result.powerConsumption = calculatePowerConsumption(
        co2Emmisions, this.other.electricityEmissions,
      );
      this.result.comparisonDataset = {
        wood: this.result.netEmmissions.project,
        concrete: formatFrenchNumber(
          parseInt(this.selectedVolume * this.materials.betonBlocs.gwpTotal, 0),
        ),
        clay: formatFrenchNumber(
          parseInt(this.selectedVolume * this.materials.briqueTerre.gwpTotal, 0),
        ),
        pouredConcrete:
        formatFrenchNumber(
          parseInt(this.selectedVolume * this.materials.betonBanche.gwpTotal, 0),
        ),
        acier:
        formatFrenchNumber(
          parseInt(this.selectedVolume * this.materials.acier.gwpTotal, 0),
        ),
        aluminium:
        formatFrenchNumber(
          parseInt(this.selectedVolume * this.materials.aluminium.gwpTotal, 0),
        ),
      };
      this.result.comparisonDatasetValues = {
        wood: parseInt(this.result.woodNetEmissions.project, 0),
        concrete: parseInt(this.selectedVolume * this.materials.betonBlocs.gwpTotal, 0),
        clay: parseInt(this.selectedVolume * this.materials.briqueTerre.gwpTotal, 0),
        pouredConcrete:
        parseInt(this.selectedVolume * this.materials.betonBanche.gwpTotal, 0),
        acier:
        parseInt(this.selectedVolume * this.materials.acier.gwpTotal, 0),
        aluminium:
        parseInt(this.selectedVolume * this.materials.aluminium.gwpTotal, 0),
      };
      this.emitCO2Calculated();
      console.log(this.result);
    },
  },
};
</script>
